export default {"src":"/_next/static/media/share-icon.4dbdccdb.svg","height":23,"width":22};